import login from './login';

export default {
  language: 'es',
  country: 'es',
  name: 'Español',
  embeddedLocale: login,
  flags: ['ES'],
};
